import { render, staticRenderFns } from "./FieldAttributes.vue?vue&type=template&id=09f77c32"
import script from "./FieldAttributes.vue?vue&type=script&lang=js"
export * from "./FieldAttributes.vue?vue&type=script&lang=js"
import style0 from "./FieldAttributes.vue?vue&type=style&index=0&id=09f77c32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports